import { render, staticRenderFns } from "./AlignmentPagination.vue?vue&type=template&id=318ca761"
import script from "./AlignmentPagination.vue?vue&type=script&lang=js"
export * from "./AlignmentPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports